import { useState } from "react";
import { Form, Input } from "antd";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsLoggedIn, setRole } from "../slices/app";
import api from "../Interceptor";
import { getRoute } from "../api/routes";
import CustomModal from "./customModal/customModal";
import ModalFooter from "./customModal/modalFooter";
import useModal from "../hooks/useModal";
import { clearFromLocalStorage } from "../utils/localStorage";
import { logout } from "../slices/authSlice";
import CompanyInfo from "./CompanyInfo";
import { validateFormHandler } from "../utils/validations/validateForm";
import DeleteAccount from "./DeleteAccount";

const LoggedInUserPopup = ({ onMenuSelect, onPopoverVisible }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [isDeleteAccountModalOpen, setIsDeleteAccountModalOpen] =
    useState(false);
  const [companyInfo, setCompanyInfo] = useState(null);
  const companyId = localStorage.getItem("companyId");
  const companyName = localStorage.getItem("companyName");
  const [name, setName] = useState(localStorage.getItem("companyName") || "");
  const [about, setAbout] = useState(
    localStorage.getItem("companyAbout") || "",
  );
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(
    companyInfo?.imagePath || "",
  );
  const [errors, setErrors] = useState({});
  const { isOpen, toggleModal } = useModal();
  const handleLogout = () => {
    // 🔹 Google logout UX fix
    if (window.google?.accounts?.id) {
      window.google.accounts.id.disableAutoSelect();
    }

    // 🔹 App logout
    localStorage.clear();
    clearFromLocalStorage();

    dispatch(logout());
    dispatch(setIsLoggedIn(false));
    dispatch(setRole(""));

    toast.success("Logged out successfully!");

    setTimeout(() => {
      navigate("/", { replace: true });
    }, 1000);
  };

  const handleAddUpdate = async () => {
    const validationErrors = validateFormHandler({
      name,
      about,
    });
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    try {
      setIsLoading(true);
      let imageUrl = imagePreview;
      if (selectedImage) {
        imageUrl = await uploadImage(selectedImage);
      }
      const response = await api.put(
        getRoute("users", "admin", "companyInfo", false),
        {
          id: companyId,
          name,
          about,
          logo: imageUrl,
        },
      );
      if (response.status !== 200) {
        throw new Error("Failed to save company info");
      }
      const data = response.data;
      localStorage.setItem("companyName", data.name);
      localStorage.setItem("companyLogo", data.logo);
      localStorage.setItem("companyAbout", data.about);
      toast.success("Company Info saved successfully");
      toggleModal();
    } catch (error) {
      toast.error("Error saving company info");
    } finally {
      setIsLoading(false);
    }
  };
  const openPasswordModal = () => {
    setIsPasswordModalOpen(true);
    if (onMenuSelect) onMenuSelect();
    if (onPopoverVisible) onPopoverVisible();
  };

  const closePasswordModal = () => {
    setIsPasswordModalOpen(false);
  };

  const openDeleteAccountModal = () => {
    setIsDeleteAccountModalOpen(true);
    if (onMenuSelect) onMenuSelect();
    if (onPopoverVisible) onPopoverVisible();
  };

  const closeDeleteAccountModal = () => {
    setIsDeleteAccountModalOpen(false);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const uploadImage = async (image) => {
    const data = new FormData();
    data.append("file", image);
    data.append("upload_preset", "ExpenseTracker");
    try {
      const response = await fetch(
        "https://api.cloudinary.com/v1_1/dqvgbgje8/image/upload",
        {
          method: "POST",
          body: data,
        },
      );
      const urlData = await response.json();
      return urlData.url;
    } catch (error) {
      toast.error("Image upload failed.");
      return null;
    }
  };

  const handleSavePassword = async (values) => {
    const { oldPassword, newPassword, confirmPassword } = values;

    if (newPassword !== confirmPassword) {
      toast.error("The two new passwords do not match!");
      return;
    }

    try {
      const response = await api.put(
        getRoute("users", "admin", "self", false, false, "updatePassword"),
        { oldPassword, newPassword, confirmPassword },
      );

      if (response.status === 200) {
        toast.success("Password updated successfully!");
        closePasswordModal();
      } else {
        const message =
          response.data?.error || response.error || "Failed to update password";
        toast.error(message);
      }
    } catch (error) {
      const message =
        error.response?.data?.error ||
        error.message ||
        "Error updating password";
      toast.error(message);
    }
  };

  return (
    <div className="w-48 bg-white z-[111]">
      <Link
        to="/setting"
        className="flex justify-between items-center cursor-pointer text-black"
        onClick={() => {
          if (onMenuSelect) onMenuSelect();
          if (onPopoverVisible) onPopoverVisible();
        }}
      >
        <span>Settings</span>
        <i className="fa-solid fa-angle-right"></i>
      </Link>

      {/* <div
        className={`flex justify-between items-center text-black border-b border-gray-300  mb-2 pb-2 
        ${isUnpaid ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
        onClick={!isUnpaid ? openPasswordModal : undefined}
      >
        <span>Update Password</span>
        <i className="fa-solid fa-angle-right"></i>
      </div> */}
      {/* <div
        className="flex justify-between items-center text-black  mb-2 pb-2 cursor-pointer"
        onClick={openDeleteAccountModal}
      >
        <span>Delete Account</span>
        <i className="fa-solid fa-angle-right"></i>
      </div> */}
      <div
        className="text-[#EB4143] border-t border-gray-300 mt-2 pt-2 text-center cursor-pointer"
        onClick={handleLogout}
      >
        <i className="fa-solid fa-arrow-right-from-bracket me-2"></i>Logout
      </div>
      <CustomModal
        isOpen={isOpen}
        onClose={toggleModal}
        modalTitle="Update Company Info"
      >
        <CompanyInfo companyId={companyId} onClose={toggleModal} />
        {/* <form
          onSubmit={(e) => {
            e.preventDefault();
            handleAddUpdate();
          }}
        >
          <div className="mb-4">
            <CustomInput
              type="text"
              label="Company Name"
              id="name"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                if (errors.name) {
                  setErrors((prev) => ({...prev, name: undefined}));
                }
              }}
              message={errors.name}
            />
          </div>
          <div className="mb-4">
            <CustomInput
              label="About"
              as="textarea"
              id="about"
              value={about}
              onChange={(e) => {
                setAbout(e.target.value);
                if (errors.about) {
                  setErrors((prev) => ({...prev, about: undefined}));
                }
              }}
              message={errors.about}
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1" htmlFor="image">
              Company Image
            </label>
            <input
              type="file"
              id="image"
              accept="image/*"
              onChange={handleImageChange}
              className="w-full border border-gray-300 rounded-lg p-2"
            />
          </div>
          {imagePreview && (
            <img src={imagePreview} alt="preview" className="mb-4 w-24 h-24" />
          )}
          <ModalFooter onCancel={toggleModal}  isLoading={isLoading}/>
        </form> */}
      </CustomModal>
      <CustomModal
        isOpen={isDeleteAccountModalOpen}
        onClose={closeDeleteAccountModal}
        modalTitle="Delete Account"
      >
        <DeleteAccount onClose={closeDeleteAccountModal} />
      </CustomModal>
      <CustomModal
        isOpen={isPasswordModalOpen}
        onClose={closePasswordModal}
        modalTitle="Update Password"
      >
        <Form onFinish={handleSavePassword}>
          <Form.Item
            name="oldPassword"
            rules={[
              { required: true, message: "Please input your old password!" },
            ]}
            className="mb-4"
          >
            <Input.Password
              placeholder="Old Password"
              className="w-full py-2 px-3 rounded-lg border border-gray-300"
            />
          </Form.Item>
          <Form.Item
            name="newPassword"
            rules={[
              { required: true, message: "Please input your new password!" },
            ]}
            className="mb-4"
          >
            <Input.Password
              placeholder="New Password"
              className="w-full py-2 px-3 rounded-lg border border-gray-300"
            />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            rules={[
              { required: true, message: "Please confirm your new password!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("The two passwords do not match!"),
                  );
                },
              }),
            ]}
            className="mb-4"
          >
            <Input.Password
              placeholder="Confirm New Password"
              className="w-full py-2 px-3 rounded-lg border border-gray-300"
            />
          </Form.Item>
          <ModalFooter onCancel={closePasswordModal} />
        </Form>
      </CustomModal>
    </div>
  );
};

export default LoggedInUserPopup;
